export default {
  getPlayItem(state) {
    return state.playItem;
  }
};
